export const initialState = {
  name: "",
  loading: false,
  success: false,
  error: false,
  warning: false,
  message: null,
};
